import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  plots: null,
}

const getters = {
  plots() {
    const url = `/Plot?typeId=1`
    return axios.get(url)
  },
  plotImageSrc(serverId) {
    const url = `/Plot/PlotImage/?plotId=${serverId}`
    return axios.get(url)
  },
  plotByIssueId(issueId) {
    const url = `/Plot?maintIssueId=${issueId}&typeId=2`
    return axios.get(url)
  },
}

const saves = {
  plots(plot) {
    if (plot.id) {
      return axios.put(`/Plot`, plot)
    } else {
      return axios.post(`/Plot`, plot)
    }
  },
}

const deletes = {
  plots(serverId) {
    return axios.delete(`/Plot/?plotId=${serverId}`)
  },
  plotIssueRelationship(params) {
    return axios.delete(
      `/MaintenanceIssue/${params.issueId}/Plot/${params.plotId}`,
    )
  },
}

export default class PlotService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
